<template>
  <div class="settings">
    <div class="settings__title">{{ $t('labels.settings')}}</div>

    <div class="settings__single" v-if="isMerchant">
      <div class="settings__block-title">{{ $t('labels.secret_key')}}</div>
      <div class="settings__container">
        <div class="settings__block">
          <div class="settings__label d-flex gap-sm align-items-center" style="max-width: none">
            <span style="font-family: monospace; word-break: break-word;">{{ user?.secret }}</span> <CopyButton :value="user?.secret"></CopyButton>
          </div>
        </div>
      </div>
    </div>

    <form class="settings__single">
      <div class="settings__block-title">{{ $t('labels.safety')}}</div>
      <div class="settings__container">
        <div class="settings__block">
          <div class="settings__label">
            {{ $t('labels.2fa')}}
          </div>
          <div class="settings__content settings__content">
            <template v-if="!user?.is2faEnabled">
              <LoaderButton :on-click="enable2fa" class="btn btn--attention settings__btn">
                <span class="text-capitalize-first">{{ $t('labels.enable')}}</span>
              </LoaderButton>
            </template>
            <template v-else>
              <span class="tfa-status text-capitalize-first">{{ $t('labels.enabled')}}</span>
              <LoaderButton class="btn btn--reset settings__btn" :on-click="disable2fa">
                <img :src="require(`@/apps/public/assets/img/close.svg`)">
                <span class="text-capitalize-first">{{ $t('labels.disable')}}</span>
              </LoaderButton>
            </template>

          </div>
        </div>
        <div class="settings__block">
          <div class="settings__label text-capitalize-first">
            {{ $t('labels.new_password')}}
          </div>
          <div class="settings__content">
            <input type="text" class="form-control" v-model="password">
          </div>
        </div>
        <div class="settings__block">
          <div class="settings__label text-capitalize-first">
            {{ $t('labels.confirm_password')}}
          </div>
          <div class="settings__content">
            <input type="text" class="form-control" v-model="passwordConfirm">
          </div>
        </div>
        <div class="settings__block">
          <div class="settings__label">

          </div>
          <div class="settings__content">
            <LoaderButton :on-click="updateProfile" type="button" class="btn settings__btn btn--accept">
              <span class="text-capitalize-first">{{ $t('button.save')  }}</span>
            </LoaderButton>
          </div>
        </div>
      </div>
    </form>
    <form class="settings__single" v-if="isTrader">
      <div class="settings__block-title">{{ $t('labels.telegram')}}</div>
      <div class="settings__container">
        <div class="settings__block">
          <div class="settings__label">
            {{ $t('labels.telegram_bot_notifications')}}
          </div>
          <div class="settings__content">
            <template v-if="telegramMe?.id" class="">
              <div class="user-nickname">
                @{{ telegramMe?.username }}
              </div>
              <LoaderButton class="btn btn--reset settings__btn" :on-click="unlinkTgAccount">
                <img :src="require(`@/apps/public/assets/img/close.svg`)">
                {{ $t('labels.telegram_unlink_account')}}
              </LoaderButton>
            </template>
            <template v-else-if="telegramMe && telegramMe?.id === null && tgBotNotificationsUrl !== null" class="">
              <a :href="tgBotNotificationsUrl" target="_blank" class="underline">{{ $t('labels.tg_click_on_link')}}</a>
            </template>
            <template v-else-if="telegramMe && telegramMe?.id === null" class="">
              <LoaderButton :on-click="createTgInviteRequest" class="btn btn--attention settings__btn">
                {{ $t('labels.telegram_link_account')}}
              </LoaderButton>
            </template>
            <a ref="tgBotNotificationsLink" href="" target="_blank" style="display: none"></a>
          </div>
        </div>
        <div class="settings__block">
          <div class="settings__label settings__label--start">
            {{ $t('labels.telegram_bot_notifications_settings')}}
          </div>
          <div class="settings__content">
            <div class="checkbox__list">
              <div class="checkbox" v-for="notification in Object.values(TgNotification)">
                <input type="checkbox" :value="notification" v-model="enabledNotifications" :id="notification" :disabled="notification === TgNotification.NOTIFICATION_WEEKLY_REPORT && !user?.tgChatGroupId">
                <label :for="notification">{{ $t(`tg_notifications.${notification}`)}}</label>
                <div v-if="notification === TgNotification.NOTIFICATION_WEEKLY_REPORT && !user?.tgChatGroupId" class="text-muted small">
                  {{ $t('labels.weekly_report_tg_group_hint') }}
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="settings__block">
          <div class="settings__label">
          </div>
          <div class="settings__content">
            <LoaderButton :on-click="saveNotifications" type="button" class="btn settings__btn btn--accept">
              <span class="text-capitalize-first">{{ $t('button.save')  }}</span>
            </LoaderButton>
          </div>
        </div>
      </div>
    </form>
    <form class="settings__single" v-if="isTrader && concurrentDealsLimitEnabled" @submit.prevent>
      <div class="settings__block-title">{{ $t('labels.concurrent_deals_limit')  }}</div>
      <div class="settings__container">
        <div class="settings__block">
          <div class="settings__label text-capitalize-first">
            {{ $t('labels.enabled')  }}
          </div>
          <div class="settings__content">
            <label class="switch">
              <input type="checkbox" v-model="isConcurrentDealsLimitEnabled">
              <span class="slider"></span>
            </label>
          </div>
        </div>
        <div class="settings__block">
          <div class="settings__label settings__label--start text-capitalize-first">
            {{ $t('labels.concurrent_deals_limit_value')  }}
          </div>
          <div class="settings__content">
            <FormInputWrapper v-slot="parentProps" field="concurrentDealsLimit" form="concurrentDealsLimit">
              <input
                :class="parentProps.class"
                v-model.number="concurrentDealsLimit"
                :disabled="!isConcurrentDealsLimitEnabled"
                type="number"
                min="1"
                class="form-control"
                id="concurrentDealsLimit"
              >
            </FormInputWrapper>
            <div class="text-muted small">
              {{ $t('labels.concurrent_deals_limit_hint')  }}
            </div>
          </div>
        </div>
        <div class="settings__block">
          <div class="settings__label">
          </div>
          <div class="settings__content">
            <LoaderButton :on-click="saveConcurrentDealsLimit" type="button" class="btn settings__btn btn--accept">
              <span class="text-capitalize-first">{{ $t('button.save')  }}</span>
            </LoaderButton>
          </div>
        </div>
      </div>
    </form>
    <form class="settings__single">
      <div class="settings__block-title">{{ $t('labels.profile')  }}</div>
      <div class="settings__container">
        <div class="settings__block">
          <div class="settings__label">
            {{ $t('labels.timezone')  }}
          </div>
          <div class="settings__content">
            <Multiselect
              class=""
              name="timezone"
              id="timezone"
              :placeholder="$t('labels.timezone')"
              :options="moment.tz.names()"
              v-model="timezone"
              select-label="Select"
              open-direction="bottom"
              autocomplete="timezone"
              :multiple="false"
              :searchable="true"
              :internal-search="true"
              :clear-on-select="false"
              :close-on-select="true"
              :options-limit="100"
              :limit="1000"
              :show-no-results="false"
              :hide-selected="false"
            >
            </Multiselect>
          </div>
        </div>
        <div class="settings__block">
          <div class="settings__label">
            {{ $t('labels.lang')  }}
          </div>
          <div class="settings__content">
            <Multiselect
              :placeholder="$t('labels.lang')"
              name="lang"
              id="lang"
              :options="['ru', 'en']"
              v-model="lang"
              select-label="Select"
              open-direction="bottom"
              autocomplete="lang"
              :multiple="false"
              :searchable="true"
              :internal-search="true"
              :clear-on-select="false"
              :close-on-select="true"
              :options-limit="100"
              :limit="1000"
              :show-no-results="false"
              :hide-selected="false"
            >
            </Multiselect>
          </div>
        </div>
        <div class="settings__block">
          <div class="settings__label">

          </div>
          <div class="settings__content">
            <LoaderButton :on-click="updateProfile" type="button" class="btn settings__btn btn--accept">
              <span class="text-capitalize-first">{{ $t('button.save')  }}</span>
            </LoaderButton>
          </div>
        </div>
      </div>
    </form>
  </div>
  <TwoFAInstallPopup ref="tfaPopup"></TwoFAInstallPopup>

</template>
<script lang="ts">
import {defineComponent, toRefs, reactive, onMounted, onUnmounted, ref, computed} from 'vue'
import {$t, helper} from "@/service/CommonHelper";
import {useStore} from "vuex";
import {useNotification} from "@kyvg/vue3-notification";
import {TgNotification} from "@/models/enum/TgNotification";
import TelegramMeDTO from "@/models/TelegramMeDTO";
import {api} from "@/service/APIClient";
import Multiselect from "vue-multiselect";
import moment from "moment/moment";
import LoaderButton from "@/apps/public/components/LoaderButton.vue";
import UserDTO from "@/models/UserDTO";
import TwoFAInstallPopup from "@/apps/public/components/TwoFAInstallPopup.vue";
import CopyButton from "@/apps/public/components/CopyButton.vue";
import FormInputWrapper from "@/components/FormInputWrapper.vue";
import TraderDTO from "@/models/TraderDTO";

export default defineComponent({
  methods: {$t},
  components: {
    CopyButton,
    FormInputWrapper,
    TwoFAInstallPopup,
    LoaderButton,
    Multiselect
  },
  setup() {
    const tgBotNotificationsLink = ref<InstanceType<any>>(null)
    const tfaPopup = ref<InstanceType<typeof TwoFAInstallPopup>|null>(null)

    const notification = useNotification()
    const store = useStore()
    const state = reactive({
      enabledNotifications: Object.values(TgNotification) as TgNotification[],
      password: null as string|null,
      timezone: store.getters.getUser?.timezone,
      lang: store.getters.getUser?.lang ?? window.userLang,
      passwordConfirm: null as string|null,
      telegramMe: null as TelegramMeDTO|null,
      tgBotNotificationsUrl: null as string|null,
      isConcurrentDealsLimitEnabled: (store.getters.getUser as TraderDTO|null)?.isConcurrentDealsLimitEnabled ?? false,
      concurrentDealsLimit: ((store.getters.getUser as TraderDTO|null)?.concurrentDealsLimit ?? null) as number|string|null,
    });

    const getTelegramMe = async () => {
      try {
        state.telegramMe = await api.getTgMe();
        const disabledNotifications = state.telegramMe?.disabledNotifications ?? []
        state.enabledNotifications = state.enabledNotifications.filter((item) => !disabledNotifications.includes(item))
      } finally {
      }
    }

    const saveNotifications = async () => {
      try {
        await api.updateTgNotifications({disabledNotifications: Object.values(TgNotification).filter((item: TgNotification) => !state.enabledNotifications.includes(item))});
        await getTelegramMe();
      } finally {
      }
    }

    const unlinkTgAccount = async () => {
      try {
        await api.deleteTgMe();
        await getTelegramMe();
      } finally {
      }
    }

    const createTgInviteRequest = async () => {
      try {
        state.tgBotNotificationsUrl = null;
        const result = await api.createTgInviteRequest();
        state.tgBotNotificationsUrl = result.startUrl;
        tgBotNotificationsLink.value!.href = result.startUrl;
        tgBotNotificationsLink.value!.click()
      } finally {
      }
    }

    const listener = async () => {
      state.telegramMe = await api.getTgMe();
    }

    onUnmounted(() => {
      document.removeEventListener('visibilitychange', listener)
    })

    onMounted(() => {
      getTelegramMe();
      document.addEventListener('visibilitychange', listener);
    });

    const updateProfile = async () => {
      if (state.password && state.password !== state.passwordConfirm) {
        notification.notify({
          title: helper.trans('profile.error.mismatch'),
          type: 'error'
        });

        return;
      }

      if (state.password && state.password.length < 5) {
        notification.notify({
          title: helper.trans('profile.error.min_length', {length: 5}),
          type: 'error'
        });

        return;
      }

      try {
        await api.updateProfile({
          plainPassword: !state.password ? null : state.password,
          timezone: state.timezone,
          lang: state.lang,
          refreshToken: store.getters.getAuth?.refreshToken
        });

        notification.notify({title: helper.trans('profile.success')});
        await store.dispatch('loadUser')
        state.password = null;
        state.passwordConfirm = null;

      } catch (e) {
        notification.notify({
          title: helper.trans('profile.failed'),
          type: 'error'
        });
      }
    }

    const saveConcurrentDealsLimit = async () => {
      helper.clearErrors('concurrentDealsLimit')

      try {
        const limit = state.concurrentDealsLimit === null || state.concurrentDealsLimit === '' ? null : Number(state.concurrentDealsLimit)
        await api.changeMeConcurrentDealsLimit(state.isConcurrentDealsLimitEnabled, limit)
        await store.dispatch('loadUser')
        notification.notify({title: helper.trans('labels.concurrent_deals_limit_saved')})
      } catch (e) {
        helper.handleErrors('concurrentDealsLimit', e)
      }
    }

    const disable2fa = async () => {
      try {
        await api.twoFactorAuthDisable();
        await store.dispatch('loadUser');
      } finally {
      }
    }

    const enable2fa = async () => {
      tfaPopup.value?.show(await api.twoFactorAuthEnable());
    }

    return {
      ...toRefs(state),
      disable2fa,
      enable2fa,
      moment,
      updateProfile,
      createTgInviteRequest,
      unlinkTgAccount,
      TgNotification,
      saveNotifications,
      saveConcurrentDealsLimit,
      tgBotNotificationsLink,
      tfaPopup,
      user: computed<UserDTO | null>(() => store.getters.getUser),
      isTrader: computed(() => store.getters.isTrader),
      isMerchant: computed(() => store.getters.isMerchant),
      concurrentDealsLimitEnabled: computed(() => !!store.getters.getAppData?.TRADER_CONCURRENT_DEALS_LIMIT_ENABLED),
      helper,
      store,
    }
  }
})
</script>
